import FetchWrapper from "./FetchWrapper";

export const GetAssignmentTypes = () => {
  return fetchApi("/assignment-types")
}

export const CreateAssignmentType = (subject) => {
  return fetchApi('/assignment-types', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(subject)
  });
}

export const UpdateAssignmentType = (id, subject) => {
  return fetchApi(`/assignment-types/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(subject)
  });
}

export const DeleteAssignmentType = (id) => {
  return fetchApi(`/assignment-types/${id}`, { method: 'DELETE' })
}